import { Panel } from './Panel';
import { usePanel } from './hooks/usePanel';
import {
  Outlet,
} from 'react-router-dom';
import React from 'react';
import { DietAndUserMealDisplay } from '../UserDashboard/DietAndUserMealDisplay';
import { PhaseFoods } from '../UserDashboard/PhaseFoods';
import { HealthCoachMindGutCard } from '../HealthCoachDashboard/HealthCoachMindGutCard';
import { Box, Separator } from '@chakra-ui/react';
import { VStack } from '@ayble-health/dashboard-components';

export const ProgressPage = () => {
  const {
    dataRange,
    isMemberViewActive,
    legendConfig,
    onSelectDataRange,
    onToggleLegendItem,
    overallSymptoms,
    timeChartConfig,
    timeChartData,
    toggleMemberView,
  } = usePanel();

  return (
    <VStack p={6}>
      <Box>
        <Panel
          data={{
            overallSymptoms,
            timeChartData,
          }}
          dataRange={dataRange}
          legendConfig={legendConfig}
          memberView={isMemberViewActive}
          onSelectDataRange={onSelectDataRange}
          onToggleLegendItem={onToggleLegendItem}
          onToggleMemberView={toggleMemberView}
          timeChartConfig={timeChartConfig}
        />
      </Box>

      <Separator my={12} />

      <DietAndUserMealDisplay />

      <PhaseFoods />

      <HealthCoachMindGutCard />

      <Outlet />
    </VStack>
  );
};
